import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AprOrPayment,
  BonusOffer,
  DownPayment,
  MainOffer,
  OffersWrapper,
  PaymentLabel,
  PaymentNumber,
  Term,
} from './VehicleInfo.styles';
import { OfferDetails } from '../../types';
import OffersTag from '../../assets/icons/OfferTagIcon';
import { priceFormat } from '../../functions/priceFormat';

interface OffersProps {
  offers: OfferDetails;
  offerType: string;
}

const Offers: React.FC<OffersProps> = ({ offers, offerType }) => {
  const { t } = useTranslation();
  const isFinanceOffer = offerType === 'finance';
  return (
    <OffersWrapper>
      <MainOffer>
        <AprOrPayment isFinanceOffer={isFinanceOffer}>
          <PaymentNumber>
            {isFinanceOffer && offers.aprRate
              ? `${(offers.aprRate * 100).toFixed(2)}%`
              : offers.monthlyPayment}
          </PaymentNumber>
          <PaymentLabel>
            {isFinanceOffer
              ? t('digitalLeads.vehicle.offers.apr')
              : t('digitalLeads.vehicle.offers.monthlyPayment')}
          </PaymentLabel>
        </AprOrPayment>
        <Term isFinanceOffer={isFinanceOffer}>
          <PaymentNumber>{offers.term}</PaymentNumber>
          <PaymentLabel>{t('digitalLeads.vehicle.offers.months')}</PaymentLabel>
        </Term>
        {!isFinanceOffer && (
          <DownPayment>
            <PaymentNumber>{priceFormat(offers.customerDownPayment)}</PaymentNumber>
            <PaymentLabel>{t('digitalLeads.vehicle.offers.downPayment')}</PaymentLabel>
          </DownPayment>
        )}
      </MainOffer>
      {!!offers.creditBonus && (
        <BonusOffer>
          <OffersTag /> {priceFormat(offers.creditBonus)}{' '}
          {t('digitalLeads.vehicle.offers.bonusOffer')}
        </BonusOffer>
      )}
    </OffersWrapper>
  );
};

export default Offers;
